// Compiled at 2026-05-13T13:50:05.286Z
// Compiled at 2026-05-13T13:50:05.286Z
// Compiled at 2026-05-13T13:50:05.286Z
// Auto-generated by Lowgile
import { Sys } from "@lg/ng-shared";
import * as Llama from "./Llama/Llama.js";
import * as System from "./System/System.js";
import * as Common from "./Common/Common.js";

export { Llama, System, Common };
Object.assign(globalThis, { Sys, Llama, System, Common, This: Llama })
